<template>
<div class="chapter">
<div class="inner_page">
<p style="margin: 0; padding: 0; text-align: center">
<a href="http://academychicago.com" target="_blank"><img alt="Cover" height="100%" id="CoverImage" src="CoverDesign.jpg" style="padding: 0; margin: 0;"/></a>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CoverPage.vue?66a7ac6f